<ion-item
  mode="md"
  color="transparent"
  lines="none"
  button
  class="getm-search-result-item"
  (click)="onItemClick()"
>
  <ng-container *ngIf="imagenThumbnail">
    <ion-thumbnail slot="start" class="thumbnail-container">
      <ion-img [src]="imagenThumbnail"></ion-img>
    </ion-thumbnail>
  </ng-container>

  <ion-label class="ellipsis">
    <ion-text
      class="getm-search-result-item-text"
      [translateFormatter]="highlightedName"
    ></ion-text>
    <br />
    <ng-container *ngIf="variante">
      <ion-text class="getm-search-result-item-variant">
        {{ variante }}
      </ion-text>
    </ng-container>
  </ion-label>

  <ng-container *ngIf="iconEnd">
    <ion-icon
      [name]="iconEnd"
      [color]="iconColor"
      class="getm-search-result-item-icon"
      slot="end"
    ></ion-icon>
  </ng-container>
</ion-item>
